import { insights } from "@/data/insights";

export default function Insights() {
  return (
    <main data-testid="page-insights" className="pt-24">
      <section className="container-x pt-16 pb-8">
        <div className="font-mono-label text-xs text-[#00F0FF] mb-4">
          / Insights
        </div>
        <h1 className="font-display text-5xl sm:text-6xl text-white tracking-tight max-w-3xl leading-[1.02]">
          Field notes from{" "}
          <span className="text-[#00FF66]">production AI.</span>
        </h1>
        <p className="mt-6 text-white/60 max-w-2xl leading-relaxed">
          Practical writing from the Pransam team — no hype, no thought
          leadership fluff. Just what we learned this quarter.
        </p>
      </section>

      <section className="container-x py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {insights.map((post, i) => (
            <article
              key={post.id}
              data-testid={`insights-item-${i}`}
              className="group rounded-2xl border border-white/10 bg-[#0F0F13] p-8 md:p-10 transition-transform duration-300 hover:-translate-y-1 hover:border-[#00F0FF]/40"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono-label text-[10px] text-[#00F0FF]">
                  {post.tag}
                </span>
                <span className="font-mono-label text-[10px] text-white/40">
                  {post.date} · {post.readTime}
                </span>
              </div>
              <h2 className="mt-6 font-display text-2xl md:text-3xl text-white tracking-tight leading-snug group-hover:text-[#00F0FF] transition-colors">
                {post.title}
              </h2>
              <p className="mt-4 text-white/60 leading-relaxed">
                {post.excerpt}
              </p>
              <div className="mt-8 font-mono-label text-[10px] text-white/40">
                READ · COMING SOON
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
